

interface LocaleFormat {
  locale: string
  code: string
}

const formats: Record<string, LocaleFormat> = {
  ja_jp: {
    locale: 'ja-JP',
    code: 'JPY',
  },
  id_id: {
    locale: 'id-ID',
    code: 'IDR',
  },
}

export interface CurrencyPlugin {
  format(amount?: number): string
  readonly symbol: string
}

export default defineNuxtPlugin((nuxtApp) => {
  const plugin: CurrencyPlugin = {
    format(amount = 0) {
      const symbol = this.symbol
      const value = Number(amount)

      const locale = (nuxtApp.$auth as any).info.location.locale
      const format = formats[locale]

      if (format) {
        const currencyFractionDigits = new Intl.NumberFormat(format.locale, {
          style: 'currency',
          currency: format.code,
        }).resolvedOptions().maximumFractionDigits

        const number = (value).toLocaleString(format.locale, {
          minimumFractionDigits: currencyFractionDigits,
        })

        return `${symbol}${number}`
      }

      const number = (value || 0).toFixed(2)
      const negative = Number(number) < 0

      if (negative) {
        return `-${symbol}${Math.abs(Number(number))}`
      }

      return `${symbol}${number}`
    },
    get symbol() {
      return (nuxtApp.$auth as any).info.location.currencySymbol
    },
  }

  nuxtApp.provide('currency', plugin)
})
